import React from "react";
import PayRoll from "../component/PayRoll";

const PayrollDashboard = () => (
  <div>
    <PayRoll />
  </div>
);

export default PayrollDashboard;
